import React, { useEffect, useRef, useState } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import VendorHeader from "../../component/VendorHeader";
import Footer from "../../component/VendorFooter";
import Sidebar from "../../component/Sidebar";
import { API_BASE_URL } from "../../utils/app_url";
import { useAuth } from "../../context/AuthContext";
import { useLanguage } from "../../context/LanguageContext";
import { NotificationManager } from "react-notifications";
import JoditEditor from "jodit-react";
import VendorFooter from "../../component/VendorFooter";

const LANGUAGES = ["en", "de", "fr", "it", "es", "ru", "tr"];

const AdminCmsEditor = () => {
  const { user } = useAuth();
  const { langJson } = useLanguage();
  const navigate = useNavigate();

  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const lang = searchParams.get("lang") || "en";

  const editorRef = useRef(null);

  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const editorConfig = {
    height: 700,          // 👈 fixed height in px
    minHeight: 700,
    maxHeight: 700,
    buttons: [
      "source",
      "bold",
      "italic",
      "underline",
      "strikethrough",
      "|",
      "ul",
      "ol",
      "|",
      "left",
      "center",
      "right",
      "justify",
      "|",
      "link",
      "image",
    ],
    uploader: {
      insertImageAsBase64URI: true,
    },
    removeButtons: ["brush", "file"],
    showXPathInStatusbar: false,
    showCharsCounter: true,
    showWordsCounter: true,
    toolbarAdaptive: true,
  };

  /* ----------------------------------
     Fetch CMS by slug + language
  -----------------------------------*/
  const fetchCms = async () => {
    try {
      setLoading(true);

      const response = await fetch(
        `${API_BASE_URL}stores/cms?slug=${slug}&lang=${lang}`,
        {
          headers: {
            Authorization: `Bearer ${user.authorisation.token}`,
          },
        }
      );

      const data = await response.json();

      if (data.res) {
        setTitle(data.data?.title || "");
        setDescription(data.data?.description || "");
      } else {
        NotificationManager.warning(data.msg || "CMS not found");
      }
    } catch (error) {
      console.error(error);
      NotificationManager.error("Failed to load CMS content");
    } finally {
      setLoading(false);
    }
  };

  /* ----------------------------------
     Update CMS
  -----------------------------------*/
  const updateCms = async () => {
    try {
      setSaving(true);

      const formData = new FormData();
      formData.append("slug", slug);
      formData.append("lang", lang);
      formData.append("title", title);
      formData.append("description", description);

      const response = await fetch(`${API_BASE_URL}stores/cms/update`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${user.authorisation.token}`,
        },
        body: formData,
      });

      const data = await response.json();

      data.res
        ? NotificationManager.success(data.msg || "CMS updated")
        : NotificationManager.warning(data.msg || "Update failed");
    } catch (error) {
      console.error(error);
      NotificationManager.error("Server error while saving CMS");
    } finally {
      setSaving(false);
    }
  };

  /* ----------------------------------
     Effects
  -----------------------------------*/
  useEffect(() => {
    fetchCms();
  }, [slug, lang]);

  /* ----------------------------------
     Helpers
  -----------------------------------*/
  const pageTitle = slug
    ?.replace(/-/g, " ")
    .replace(/\b\w/g, (l) => l.toUpperCase());

  const onLanguageChange = (e) => {
    navigate(`?lang=${e.target.value}`);
  };

  /* ----------------------------------
     Render
  -----------------------------------*/
  return (
    <div>
      <div className="dashHeader">
        <VendorHeader />
      </div>

      <div className="adminDash">
        <Sidebar />

        <div className="rightSide">
          <div className="MainSection">
            <h2>
              {langJson?.cms} – {pageTitle}
            </h2>

            <select value={lang} onChange={onLanguageChange} style={{ width: '50%' }}>
              {LANGUAGES.map((l) => (
                <option key={l} value={l}>
                  {l.toUpperCase()}
                </option>
              ))}
            </select>

            {/* <li>
              <label>{langJson?.currency}</label>
              <select name="currency" onChange={handleChange} value={addFormData.currency}>
                {currency?.map((item, index) => (
                  <option key={index} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </li> */}
          </div>

          {loading ? (
            <p>{langJson?.pleasewait}</p>
          ) : (
            <>
              {/* <div className="MainSection">
                <label className="cmsLevel">Title</label>
                <input
                  type="text"
                  className="cmsInput"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="Page title"
                />
              </div> */}

              <div className="MainSection">

                <JoditEditor
                  ref={editorRef}
                  value={description}
                  config={editorConfig}
                  onChange={(value) => setDescription(value)}
                />
              </div>

              <div className="fullWidth saveBtn addAddress">
                <button
                  type="button"
                  disabled={saving}
                  onClick={updateCms}
                >
                  {saving ? langJson?.pleasewait : langJson?.savechanges}
                </button>
              </div>
            </>
          )}
        </div>
      </div>

      <VendorFooter />
    </div >
  );
};

export default AdminCmsEditor;
